/**
 * Devuelve true si el texto es una URL absoluta con esquema `http:` o `https:`.
 * Cualquier otro esquema, como `javascript:` o `data:`, da false.
 */
export const esEnlaceAbrible = (url: string | null | undefined): url is string => {
  if (!url) return false
  try {
    const { protocol } = new URL(url)
    return protocol === 'http:' || protocol === 'https:'
  } catch {
    return false
  }
}

/**
 * Abre el enlace en una pestaña nueva, sin acceso a esta ventana ni referrer.
 * Si el enlace no es `http:` ni `https:`, no hace nada.
 */
export const abrirEnlace = (url: string): void => {
  if (!esEnlaceAbrible(url)) return
  window.open(new URL(url).href, '_blank', 'noopener,noreferrer')
}

/**
 * Abre la pestaña en el gesto y la lleva a una URL que se firma después: Safari bloquea un
 * `window.open` posterior a un await. Con `noopener` devolvería null siempre, así que el opener se
 * corta a mano. Si la firma falla o no es `http:` ni `https:`, cierra la pestaña y propaga el error.
 * Devuelve 'bloqueada' sin pedir la firma si el navegador no abrió la pestaña.
 */
export const abrirEnlaceFirmado = async (firmar: () => Promise<string>): Promise<'abierta' | 'bloqueada'> => {
  const pestana = window.open('', '_blank')
  if (!pestana) return 'bloqueada'
  pestana.opener = null
  try {
    const url = await firmar()
    if (!esEnlaceAbrible(url)) throw new Error('La URL firmada no es http ni https')
    pestana.location.href = url
    return 'abierta'
  } catch (error) {
    pestana.close()
    throw error
  }
}
